import { AdvanceFilterOptionType } from '@/constants/advance-filter'

export const AttributeFieldType = Object.freeze({
  Phone: 'phone',
  Text: 'text',
  Textarea: 'textarea',
  Number: 'number',
  Date: 'date',
  Select: 'select',
  MultiSelect: 'multi-select',
})

export const AttributeFieldTypeContext = Object.freeze({
  [AttributeFieldType.Phone]: 'Kiểu số điện thoại',
  [AttributeFieldType.Text]: 'Kiểu chữ',
  [AttributeFieldType.Textarea]: 'Kiểu văn bản',
  [AttributeFieldType.Number]: 'Kiểu số',
  [AttributeFieldType.Date]: 'Kiểu ngày tháng',
  [AttributeFieldType.Select]: 'Kiểu chọn một giá trị',
  [AttributeFieldType.MultiSelect]: 'Kiểu chọn nhiều giá trị',
})

export const UserFieldTypeOptions = [
  {
    label: AttributeFieldTypeContext[AttributeFieldType.Phone],
    value: AttributeFieldType.Phone,
  },
  {
    label: AttributeFieldTypeContext[AttributeFieldType.Text],
    value: AttributeFieldType.Text,
  },
  {
    label: AttributeFieldTypeContext[AttributeFieldType.Textarea],
    value: AttributeFieldType.Textarea,
  },
  {
    label: AttributeFieldTypeContext[AttributeFieldType.Date],
    value: AttributeFieldType.Date,
  },
  {
    label: AttributeFieldTypeContext[AttributeFieldType.Number],
    value: AttributeFieldType.Number,
  },
  {
    label: AttributeFieldTypeContext[AttributeFieldType.Select],
    value: AttributeFieldType.Select,
  },
  {
    label: AttributeFieldTypeContext[AttributeFieldType.MultiSelect],
    value: AttributeFieldType.MultiSelect,
  },
]

export const TicketFieldTypeOptions = [
  {
    label: AttributeFieldTypeContext[AttributeFieldType.Text],
    value: AttributeFieldType.Text,
  },
  {
    label: AttributeFieldTypeContext[AttributeFieldType.Textarea],
    value: AttributeFieldType.Textarea,
  },
  {
    label: AttributeFieldTypeContext[AttributeFieldType.Date],
    value: AttributeFieldType.Date,
  },
  {
    label: AttributeFieldTypeContext[AttributeFieldType.Number],
    value: AttributeFieldType.Number,
  },
  {
    label: AttributeFieldTypeContext[AttributeFieldType.Select],
    value: AttributeFieldType.Select,
  },
  {
    label: AttributeFieldTypeContext[AttributeFieldType.MultiSelect],
    value: AttributeFieldType.MultiSelect,
  },
]

export const TicketTemplateAccessType = Object.freeze({
  AllAgent: 'all-agent',
  GroupAgent: 'group-agent',
  OnlyMe: 'only-me',
  Agent: 'agents',
})

export const TicketTemplateAccessTypeContext = Object.freeze({
  [TicketTemplateAccessType.AllAgent]: 'Tất cả chuyên viên',
  [TicketTemplateAccessType.GroupAgent]: 'Tất cả chuyên viên thuộc bộ phận',
  [TicketTemplateAccessType.Agent]: 'Chỉ các chuyên viên',
  [TicketTemplateAccessType.OnlyMe]: 'Chỉ mình tôi',
})

export const TicketTemplateAccessTypeOptions = [
  {
    label: TicketTemplateAccessTypeContext[TicketTemplateAccessType.AllAgent],
    value: TicketTemplateAccessType.AllAgent,
  },
  {
    label: TicketTemplateAccessTypeContext[TicketTemplateAccessType.GroupAgent],
    value: TicketTemplateAccessType.GroupAgent,
  },
  {
    label: TicketTemplateAccessTypeContext[TicketTemplateAccessType.Agent],
    value: TicketTemplateAccessType.Agent,
  },

  {
    label: TicketTemplateAccessTypeContext[TicketTemplateAccessType.OnlyMe],
    value: TicketTemplateAccessType.OnlyMe,
  },
]

export const SchedulePeriodTimeType = Object.freeze({
  DayOff: '0',
  Working: '1',
})

export const DefaultUserField = [
  {
    id: 'user:name',
    text: 'Họ và tên chuyên viên',
    type: 'user',
    field: 'name',
  },
  {
    id: 'user:phone',
    text: 'Số điện thoại chuyên viên',
    type: 'user',
    field: 'phone',
  },
  {
    id: 'user:email',
    text: 'Email chuyên viên',
    type: 'user',
    field: 'email',
  },
  {
    id: 'user:role',
    text: 'Vai trò chuyên viên',
    type: 'user',
    field: 'role',
  },
  {
    id: 'user:group_id',
    text: 'Bộ phận chuyên viên',
    type: 'user',
    field: 'group_id',
  },
  {
    id: 'user:organize_id',
    text: 'Tổ chức chuyên viên',
    type: 'user',
    field: 'organize_id',
  },
]
export const DefaultContactField = [
  {
    id: 'contact:name',
    text: 'Họ và tên khách hàng',
    type: 'contact',
    field: 'name',
  },
  {
    id: 'contact:phone',
    text: 'Số điện thoại khách hàng',
    type: 'contact',
    field: 'phone',
  },
  {
    id: 'contact:email',
    text: 'Email khách hàng',
    type: 'contact',
    field: 'email',
  },
  {
    id: 'contact:address',
    text: 'Địa chỉ',
    type: 'contact',
    field: 'address',
  },
  {
    id: 'contact:note',
    text: 'Ghi chú khách hàng',
    type: 'contact',
    field: 'note',
  },
  {
    id: 'contact:customer_type',
    text: 'Hạng khách hàng',
    type: 'contact',
    field: 'customer_type',
  },
]

export const DefaultContactFieldImport = [
  {
    id: 'contact:name',
    text: 'Tên khách hàng',
    field: 'name',
  },
  {
    id: 'contact:phone',
    text: 'Số điện thoại',
    field: 'phone',
  },
  {
    id: 'contact:email',
    text: 'Email',
    field: 'email',
  },
  {
    text: 'Giới tính',
    field: 'gender',
  },
  {
    text: 'Ngày sinh',
    field: 'dob',
    fieldType: AdvanceFilterOptionType.Date,
  },
  {
    id: 'contact:address',
    text: 'Địa chỉ',
    field: 'address',
  },
  {
    id: 'contact:note',
    text: 'Ghi chú',
    field: 'note',
  },
]
export const DefaultTicketField = [
  {
    id: 'ticket:code',
    text: 'Mã ticket',
    type: 'ticket',
    field: 'code',
  },
  {
    id: 'ticket:subject',
    text: 'Tiêu đề ticket',
    type: 'ticket',
    field: 'subject',
  },
  {
    id: 'ticket:type_id',
    text: 'Loại ticket',
    type: 'ticket',
    field: 'type_id',
  },
  {
    id: 'ticket:duedate',
    text: 'Hạn xử lý',
    type: 'ticket',
    field: 'duedate',
    fieldType: AdvanceFilterOptionType.Date,
  },
  {
    id: 'ticket:source_detail',
    text: 'Nguồn của ticket',
    type: 'ticket',
    field: 'source_detail',
  },
  {
    id: 'ticket:status',
    text: 'Trạng thái',
    type: 'ticket',
    field: 'status',
  },
  {
    id: 'ticket:priority_id',
    text: 'Độ ưu tiên',
    type: 'ticket',
    field: 'priority_id',
  },
]

export const SmartViewScopeView = Object.freeze({
  System: 'system',
  Admin: 'administrator',
  TeamLeader: 'team_leader',
})

export const SmartViewScopeViewContext = Object.freeze({
  [SmartViewScopeView.System]: 'Hệ thống',
  [SmartViewScopeView.Admin]: 'Admin',
  [SmartViewScopeView.TeamLeader]: 'Trưởng bộ phận',
})

export const SmartViewScopeViewAdminOptions = [
  {
    label: SmartViewScopeViewContext[SmartViewScopeView.Admin],
    value: SmartViewScopeView.Admin,
  },
  {
    label: SmartViewScopeViewContext[SmartViewScopeView.TeamLeader],
    value: SmartViewScopeView.TeamLeader,
  },
]

export const SmartViewScopeViewTeamLeaderOptions = [
  {
    label: SmartViewScopeViewContext[SmartViewScopeView.TeamLeader],
    value: SmartViewScopeView.TeamLeader,
  },
]

export const SmartViewScopeAccess = Object.freeze({
  OnlyMe: 'only_me',
  AllAgent: 'all_agent',
  Agents: 'agents',
  Groups: 'groups',
})

export const SmartViewScopeAccessSelectContext = Object.freeze({
  [SmartViewScopeAccess.Agents]: 'Chuyên viên',
  [SmartViewScopeAccess.Groups]: 'Bộ phận',
  [SmartViewScopeAccess.OnlyMe]: 'Chỉ mình tôi',
  [SmartViewScopeAccess.AllAgent]: 'Tất cả chuyên viên',
})

export const SmartViewScopeAccessDisplayContext = Object.freeze({
  [SmartViewScopeAccess.Agents]: 'Chỉ các chuyên viên',
  [SmartViewScopeAccess.Groups]: 'Tất cả chuyên viên thuộc bộ phận',
  [SmartViewScopeAccess.OnlyMe]: 'Chỉ mình tôi',
  [SmartViewScopeAccess.AllAgent]: 'Tất cả chuyên viên',
})

export const SmartViewScopeAccessAdminOptions = [
  {
    label: SmartViewScopeAccessSelectContext[SmartViewScopeAccess.Agents],
    value: SmartViewScopeAccess.Agents,
  },
  {
    label: SmartViewScopeAccessSelectContext[SmartViewScopeAccess.Groups],
    value: SmartViewScopeAccess.Groups,
  },
  {
    label: SmartViewScopeAccessSelectContext[SmartViewScopeAccess.OnlyMe],
    value: SmartViewScopeAccess.OnlyMe,
  },
  {
    label: SmartViewScopeAccessSelectContext[SmartViewScopeAccess.AllAgent],
    value: SmartViewScopeAccess.AllAgent,
  },
]

export const SmartViewScopeAccessTeamLeaderOptions = [
  {
    label: SmartViewScopeAccessSelectContext[SmartViewScopeAccess.Agents],
    value: SmartViewScopeAccess.Agents,
  },
  {
    label: SmartViewScopeAccessSelectContext[SmartViewScopeAccess.OnlyMe],
    value: SmartViewScopeAccess.OnlyMe,
  },
  {
    label: SmartViewScopeAccessSelectContext[SmartViewScopeAccess.AllAgent],
    value: SmartViewScopeAccess.Groups,
  },
]

export const SmartViewGroupRole = Object.freeze({
  Agent: 'agents',
  TeamLeader: 'team_leader',
  AllAgent: 'all_agent',
  AllMember: 'all_member',
})

export const SmartViewScopeAccessGroupDisplayContext = Object.freeze({
  [SmartViewGroupRole.AllMember]: 'Bộ phận',
  [SmartViewGroupRole.AllAgent]: 'Chuyên viên thuộc bộ phận',
  [SmartViewGroupRole.TeamLeader]: 'Trưởng bộ phận',
  [SmartViewGroupRole.Agent]: 'Chỉ các chuyên viên',
})

export const SmartViewGroupRoleContext = Object.freeze({
  [SmartViewGroupRole.AllMember]: 'Tất cả thành viên',
  [SmartViewGroupRole.AllAgent]: 'Chuyên viên',
  [SmartViewGroupRole.TeamLeader]: 'Trưởng nhóm',
})

export const SmartViewGroupRoleOptions = [
  {
    label: SmartViewGroupRoleContext[SmartViewGroupRole.TeamLeader],
    value: SmartViewGroupRole.TeamLeader,
  },
  {
    label: SmartViewGroupRoleContext[SmartViewGroupRole.AllMember],
    value: SmartViewGroupRole.AllMember,
  },
  {
    label: SmartViewGroupRoleContext[SmartViewGroupRole.AllAgent],
    value: SmartViewGroupRole.AllAgent,
  },
]

export const SmartViewSortDirection = Object.freeze({
  ASC: 'ASC',
  DESC: 'DESC',
})

export const SmartViewSortDirectionContext = Object.freeze({
  [SmartViewSortDirection.ASC]: 'Tăng dần',
  [SmartViewSortDirection.DESC]: 'Giảm dần',
})

export const SmartViewConditionType = Object.freeze({
  And: 'and',
  Or: 'or',
})

export const SmartViewRequiredColumnCodes = ['code', 'subject']

export const SmartViewRuleRelation = Object.freeze({
  And: 'and',
  Or: 'or',
})

export const SmartViewRuleRelationContext = Object.freeze({
  [SmartViewRuleRelation.And]: 'Tất cả',
  [SmartViewRuleRelation.Or]: 'Bất kỳ',
})

export const SmartViewRuleRelationOptions = [
  {
    label: SmartViewRuleRelationContext[SmartViewRuleRelation.And],
    value: SmartViewRuleRelation.And,
  },
  {
    label: SmartViewRuleRelationContext[SmartViewRuleRelation.Or],
    value: SmartViewRuleRelation.Or,
  },
]
